import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';
import { MyUtils } from 'src/app/services/my-utils.service';

@Component({
  selector: 'app-help-desk',
  templateUrl: './help-desk.component.html',
  styleUrls: ['./help-desk.component.css']
})
export class HelpDeskComponent implements OnInit {
  infos!: any;
  objectKeys = Object.keys;
  infosHtml!: any[];
  helpDeskEmail = 'focus-helpdesk@roarinc.com';


  constructor(
    private sanitizer: DomSanitizer,
    public utils: MyUtils,
    private authService: AuthService

  ) { }

  public get isIapAseanMea(): boolean {
    const region = this.authService.meSelectValue?.region;
    return region === 'IAP' || region === 'ASEAN' || region === 'MEA';
  }
  ngOnInit() {

    if (!this.isIapAseanMea) {
      this.utils.getHelpDesk(this.authService.meSelectValue!.roles, this.authService.meSelectValue, (this.authService.meSelectValue!.market as any)).subscribe(
        (infos: any) => {
          this.infos = infos;
          this.infosHtml = []
          Object.keys(infos).forEach(key => {
            this.infosHtml.push(this.sanitizer.bypassSecurityTrustHtml(this.infos[key] ? this.infos[key] : ''))
          })
        }
      )
    }
  }
  
}
